module.exports = __webpack_public_path__ + "assets/4bcec4b5e63634def1cb7799e0c9a6de.svg";